(ns app.legacy-subscription.plans)

(def plans
  {24330 "Instagram Accounts Monthly (Sandbox)"
   762532 "Instagram Accounts Monthly"

   25498 "Instagram Accounts Yearly (Sandbox)"
   762533 "Instagram Accounts Yearly"

   21087 "Enterprise Yearly (Sandbox)"
   661930 "Enterprise Yearly"

   21086 "Professional Yearly (Sandbox)"
   655052 "Professional Yearly"

   21085 "Standard Yearly (Sandbox)"
   655056 "Standard Yearly"

   21084 "Enterprise (Sandbox)"
   661920 "Enterprise"

   21083 "Professional (Sandbox)"
   533343 "Professional"

   21082 "Standard (Sandbox)"
   533342 "Standard"})
